import React from "react";
import GuideHeader from "../Guide/GuideHeader";
import "./GuidePersonalising.css";

const GuidePersonalising = () => {
  const tips = [
    {
      number: 1,
      title: "Include your customer’s name",
      text: `Using a subscriber’s name can help your email stand out in their inbox, so use it in your subject line and in the body of your email using merge tags.
      
For example, your subject line could read “Morgan, here’s a special discount to start your weekend.” 
Your email could open “Hi Morgan, here’s 50% off as a special thank you for being a subscriber!”`,
    },
    {
      number: 2,
      title: "Add personalised images",
      text: `Don’t forget that images can be personalised as well as text. Here’s one idea: if you know where in the world your subscribers live, you can tailor images that will mean something to them.

For example, if you’re selling swimwear you could use a photo of Bondi Beach for your Australian audience and Miami Beach for your American audience.`,
    },
    {
      number: 3,
      title: "Make personalised offers",
      text: `We all love receiving special offers, but they’re only really special when we’re being offered something we actually want. Think about what you know about your audience and use that data to craft the perfect offer for them – like their location, previous purchases or services they’ve expressed an interest in, or any other details you have.

For example, if you have multiple lists where people have signed up to receive information on different products or services, you could offer free flash hooks to the subscribers on your swimwear list.`,
    },
  ];

  return (
    <div className="guide-page">
      {/* ✅ Shared Mailsnappy Header */}
      <GuideHeader headingLevel="div" />

      {/* 📧 Page Content */}
      <section className="personalising-content">
        <h1>Personalising your email campaigns</h1>
        <p className="intro-text">
          Personalising your emails will make them feel more relevant and tailored to your audience – 
          resulting in more opens and clicks. Making each subscriber feel like your campaign is written 
          just for them can help you get the results you’re looking for.
        </p>

        <p className="intro-sub">
          Here are three ways you can start to personalise your campaigns:
        </p>

        <div className="personalising-tips">
          {tips.map((tip) => (
            <div key={tip.number} className="tip-box">
              <div className="tip-number">{tip.number}</div>
              <div className="tip-content">
                <h3>{tip.title}</h3>
                <p>{tip.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="next-step">
          <p>
            Now for the penultimate step. With the email built, now you just need to go ahead and send it 
            to your subscribers. But before doing so...
          </p>
          <p className="next-link">
            Read how to <a href="/guide">schedule your campaigns →</a>
          </p>
        </div>
      </section>

      {/* 🌊 CTA Section */}
      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
      </section>
    </div>
  );
};

export default GuidePersonalising;
